import classNames from "classnames";
import React, { useEffect, useState, useRef, useCallback } from "react";
import Search from "../../components/Search";
import Hint from "../../components/Hint/Hint";
import { useSelector } from "react-redux";
import { removeDecimal } from "../../apis/utils";
import coinLogos from "../../assets/images/currency-icons/coinLogos.js";
import { BigNumber, ethers } from "ethers";
import { Web3Context } from "../../contexts/Web3Context";

export default function ({ active, items, onChange, className, toogleForm }) {
  const assets = useSelector((state) => state.modal.data.assets);
  const currentAsset = useSelector((state) => state.modal.data.asset);

  const [opened, setOpened] = useState(false);
  const [list, setList] = useState(assets);
  const ref = useRef();

  const clickHandler = (callateral) => {
    if (callateral !== active) {
      setOpened(false);
      onChange(callateral);
    }
  };

  const searchChange = (event) => {
    // Include debounce or throttle
    const value = event.target.value.trim().toLowerCase();
    const currentList = assets.filter((asset) =>
      asset.name.toLowerCase().includes(value)
    );

    if (value === "") {
      return setList(assets);
    }

    if (currentList.length > 0) {
      return setList(currentList);
    }

    return setList([]);
  };

  const clickOutTheWindow = useCallback((e) => {
    if (ref.current && e.target.closest(".selectwithsearch") !== ref.current) {
      setOpened(false);
    }
  }, []);

  useEffect(() => {
    document.addEventListener("click", clickOutTheWindow);

    return () => document.removeEventListener("click", clickOutTheWindow);
  }, []);

  return (
    <div
      ref={ref}
      className={classNames("selectwithsearch", {
        opened: opened,
        [className]: !!className,
      })}
    >
      <div
        className="selectwithsearch__title"
        onClick={() => {
          setOpened(!opened);
          toogleForm(!opened);
        }}
      >
        <div className="selectwithsearch__title-currency">
          <img src={coinLogos[active.index]} alt="" />
          <span>{active.name}</span>
        </div>
      </div>
      {opened && (
        <div className="selectwithsearch__list">
          <div className="selectwithsearch__search">
            <Search
              name="search"
              placeholder="Search"
              onChange={searchChange}
            />
          </div>
          <div className="selectwithsearch__list-items custom-scrollbar">
            {list.map((asset) =>
              currentAsset.tier >= asset.tier &&
              currentAsset.name != asset.name ? (
                <div
                  className={classNames("selectwithsearch__item", {
                    active: asset === active,
                  })}
                  key={asset.name}
                  onClick={clickHandler.bind(null, asset)}
                >
                  <div className="selectwithsearch__item-currency">
                    <img src={coinLogos[asset.index]} alt="icon" />
                    <span>{asset.name}</span>
                  </div>
                  <div className="selectwithsearch__item-star">
                    <Hint
                      hintContent="Category 1 tokens can be used as collateral to borrow category 1, 2, 3 and 4 tokens"
                      posY="bottom"
                      posX="left"
                      maxWidth={350}
                      edgeCut={5}
                    >
                      <span>{asset.tier}</span>
                    </Hint>
                  </div>
                </div>
              ) : (
                <div></div>
              )
            )}
            {assets.length === 0 && <div>Нет совпадений</div>}
          </div>
        </div>
      )}
    </div>
  );
}
